import { Column } from "react-table";
import React from 'react'

export default [
    {
        Header: 'First name',
        accessor: 'first_name'
    },
    {
        Header: 'Last name',
        accessor: 'last_name'
    },
    {
        Header: 'Email',
        accessor: 'email'
    },
    {
        Header: 'Payment',
        accessor: 'payment',
        width: 100
    },
    {
        Header: <span title="Photos">Ph.</span>,
        accessor: 'participations_count',
        width: 25
    },
    { 
        Header: <span title="Acceptances">Acc.</span>,
        accessor: 'acceptances_count',
        width: 25
    },
    { 
        Header: <span title="Awards">Aw.</span>,
        accessor: 'awards_count',
        width: 25
    }
] as Column<Club.Resources.SalonMembership>[]